import * as React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { DisclaimerMain } from '@shared/components/disclaimer-main'

export const mainBlock: MainBlock = {
	title: 'Кредит под залог автомобиля',
	subtitle: 'Получите деньги на любые цели и продолжайте пользоваться своим авто',
	textItems: [
		'ПТС и авто остаётся у вас ',
		'До 500 тысяч за один день',
		'Срок до 5 лет с возможностью продления',
	],
	buttonText: 'Оставить заявку',
	footDisclaimer: <DisclaimerMain />,
	faceImageName: {
		mobile: 'KV-loans-business-car-mob.png',
		default: 'KV-loans-business-car.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
